module.exports = __webpack_public_path__ + "static/media/comp.6a874ca6.png";